// Compact elapsed-time label: `45s`, `3m`, `2h`, `5d`. Pass ' ago' for feed-row phrasing.
export function timeAgo(timestamp: number, suffix = ''): string {
  const sec = Math.max(0, Math.floor((Date.now() - timestamp) / 1000));
  if (sec < 60) return `${sec}s${suffix}`;
  const min = Math.floor(sec / 60);
  if (min < 60) return `${min}m${suffix}`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr}h${suffix}`;
  return `${Math.floor(hr / 24)}d${suffix}`;
}
